// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"c3535697","995":"c512bfb3"}[chunkId] + ".chunk.js";
};